/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  echoId,
  files,
  cannedResponseAttachmentIds = [],
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  templateParams,
}) => {
  let payload;
  if (
    (files && files.length !== 0) ||
    (cannedResponseAttachmentIds && cannedResponseAttachmentIds.length !== 0)
  ) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    if (files && files.length) {
      files.forEach(file => {
        payload.append('attachments[]', file);
      });
    }
    if (cannedResponseAttachmentIds && cannedResponseAttachmentIds.length) {
      cannedResponseAttachmentIds.forEach(id => {
        payload.append('canned_response_attachment_ids[]', id);
      });
    }
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);

    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (contentAttributes) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      content_attributes: contentAttributes,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      template_params: templateParams,
    };
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    echo_id: echoId,
    files,
    cannedResponseAttachmentIds = [],
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    templateParams,
  }) {
    return axios({
      method: 'post',
      url: `${this.url}/${conversationId}/messages`,
      data: buildCreatePayload({
        message,
        isPrivate,
        contentAttributes,
        echoId,
        files,
        cannedResponseAttachmentIds,
        ccEmails,
        bccEmails,
        toEmails,
        templateParams,
      }),
    });
  }

  delete(conversationID, messageId) {
    return axios.delete(`${this.url}/${conversationID}/messages/${messageId}`);
  }

  retry(conversationID, messageId) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/retry`
    );
  }

  getPreviousMessages({ conversationId, after, before }) {
    const params = { before };
    if (after && Number(after) !== Number(before)) {
      params.after = after;
    }
    return axios.get(`${this.url}/${conversationId}/messages`, { params });
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/translate`,
      {
        target_language: targetLanguage,
      }
    );
  }

  forwardMessage(conversationId, messageId, targetConversationId) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/forward`,
      {
        target_conversation_id: targetConversationId,
      }
    );
  }

  togglePin(conversationId, messageId) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/toggle_pin`
    );
  }

  addReaction(conversationId, messageId, emoji) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/reactions`,
      { emoji }
    );
  }

  removeReaction(conversationId, messageId) {
    return axios.delete(
      `${this.url}/${conversationId}/messages/${messageId}/reactions`
    );
  }

  async getConversationsByInbox(inboxId) {
    try {
      const response = await axios.get(this.url, {
        params: {
          inbox_id: inboxId,
          status: 'all',
          assignee_type: 'all',
        },
      });

      return { data: response.data.data?.payload || [] };
    } catch (error) {
      return { data: [] };
    }
  }
}

export default new MessageApi();
